import React from 'react';
import './CurrentProcess.scss';

function CurrentProcess({ psData }) {
    if (!psData) return <div>No Data</div>
    return (
        <div className='currentProcess statusPanel'>
            <h3 className='psPanelTitle'>공정 현황</h3>
            <ul className='rowUl'>
                <li className='rowLi'>
                    <ul className='colUl'>
                        <li className='colLi'>
                            <p>차종 :　<span>{psData.Model.modelType}</span></p>
                        </li>
                        <li className='colLi'>
                            <p>품명 :　<span>{psData.Model.modelName}</span></p>
                        </li>
                    </ul>
                </li>
                <li className='rowLi'>
                    <ul className='colUl'>
                        <li className='colLi'>
                            <p>품번 :　<span>{psData.Model.modelNo}</span></p>
                        </li>
                        <li className='colLi'>
                            <p>다이 높이 :　<span>{psData.Model.tblHeight ?? 0}mm</span></p>
                        </li>
                    </ul>
                </li>
                <li className='rowLi'>
                    <ul className='colUl'>
                        <li className='colLi'>
                            <p>생산 개수 :　<span>{psData.totalProduce ?? 0}</span></p>
                        </li>
                        <li className='colLi'>
                            <p>작업자 :　<span>{psData.User.userName}</span></p>
                        </li>
                    </ul>
                </li>
            </ul>

        </div>
    );
}

export default CurrentProcess;